module.exports = __webpack_public_path__ + "static/waser-1f02c8f0ebd5ed8c5a7c7a23d433a5d4.png";